import { locateID } from "@xbs/lib-dom";
import { isSameId } from "../helpers";
export function keyNavigation(node, config) {
    let activeWidgetId;
    const handleFocus = (event) => {
        activeWidgetId = locateID(event, "data-todo-id");
    };
    const handleKeyDown = (event) => {
        if (isSameId(config.widgetId, activeWidgetId)) {
            config.api.exec("keypress-on-todo", {
                code: getKeyCode(event),
                event,
            });
        }
    };
    node.addEventListener("mousedown", handleFocus);
    node.addEventListener("focusin", handleFocus);
    node.addEventListener("keydown", handleKeyDown);
    return {
        destroy() {
            node.removeEventListener("mousedown", handleFocus);
            node.removeEventListener("focusin", handleFocus);
            node.removeEventListener("keydown", handleKeyDown);
        },
    };
}
function getKeyCode(event) {
    const keyCode = [];
    let code = event?.code.toLowerCase();
    const key = event?.key.toLowerCase();
    const isKey = code.startsWith("key");
    const isDigit = code.startsWith("digit");
    const isNumpad = code.startsWith("numpad");
    const modKeys = ["control", "alt", "shift"];
    if (event.ctrlKey || event.metaKey)
        keyCode.push("ctrl");
    if (event.shiftKey)
        keyCode.push("shift");
    if (event.altKey)
        keyCode.push("alt");
    if (isKey)
        code = code.replace("key", "");
    if (isDigit)
        code = code.replace("digit", "");
    if (isNumpad)
        code = code.replace("numpad", "");
    if (!modKeys.includes(key)) {
        keyCode.push(code);
    }
    return keyCode.join("+");
}
//# sourceMappingURL=keyNavigation.js.map